const ZOHO_SRC =
  'https://salesiq.zohopublic.in/widget?wc=siq6819f6263d8dad7e7566213151b3ac283651dc413c53dd3e9074a8a1b079982e';

function ensureZohoScript() {
  if (document.getElementById('zsiqscript')) return;
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || { ready: function () {} };
  const s = document.createElement('script');
  s.id = 'zsiqscript';
  s.defer = true;
  s.src = ZOHO_SRC;
  document.body.appendChild(s);
}

export function openZohoChat() {
  if (typeof window === 'undefined') return;

  const showChat = () => {
    try {
      if (window.$zoho?.salesiq?.floatwindow?.visible) {
        window.$zoho.salesiq.floatwindow.visible('show');
        return true;
      }
    } catch {
      /* ignore */
    }
    return false;
  };

  if (showChat()) return;

  ensureZohoScript();

  const priorReady = window.$zoho?.salesiq?.ready;
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || {};
  window.$zoho.salesiq.ready = function ready() {
    if (typeof priorReady === 'function') priorReady();
    showChat();
  };

  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (showChat() || tries > 40) clearInterval(timer);
  }, 250);
}
